module.exports = __webpack_public_path__ + "img/angststoerungen1_640.b89b410c.png";